import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Token} from "../api";

export class TokenService extends RestService<Token> {
    constructor() {
        super(REST_API_END_POINTS.TOKENS)
    }

    fetch_token_info(location_code, token) {
        return this.instance.get(
            `${this.url}fetch_token_info/${location_code}/${token}/`
        )
    }

    mark_close(tokenId) {
        return this.instance.get(
            `${this.url}mark_close/${tokenId}/`
        )
    }

    makeGetRequestForAll(search_object) {
        search_object.all = true
        return this.instance.get(this.url, {params: search_object})
    }


}
